var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-col", { attrs: { cols: "12" } }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.date,
          expression: "date",
        },
      ],
      staticClass: "form-control",
      attrs: { placeholder: "MM/dd/yyyy" },
      domProps: { value: _vm.date },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.date = $event.target.value
        },
      },
    }),
    _c("small", [
      _vm._v("Enter " + _vm._s(_vm.type) + " - Month / Day / Year"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }